'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@mantine/core';
import styles from './FlyingText.module.css';

interface FlyingTextProps {
  title: string;
  description: string;
  imageUrl: string;
  backgroundColor?: string;
  textColor?: string;
  titleColor?: string;
  buttonColor?: string;
  showButton?: boolean;
  buttonText?: string;
  link?: string;
}

const FlyingText: React.FC<FlyingTextProps> = ({
  title,
  description,
  imageUrl,
  backgroundColor = '#000000',
  textColor = '#ffffff',
  titleColor = '#FFCC00',
  buttonColor = 'FFD700',
  showButton = false,
  buttonText = 'En savoir plus',
  link = '/',
}) => {
  return (
    <div className={styles.blockWrapper} style={{ backgroundColor }}>
      <div className={styles.gridLayout}>
        <div className={styles.leftSide} style={{ color: textColor }} data-aos="fade">
          <div className={styles.textContent}>
            <p className={styles.description}>{description}</p>
            {showButton && (
              <Button
                component={Link}
                href={link}
                className={styles.button}
                style={{
                  backgroundColor: buttonColor,
                  color: backgroundColor,
                }}
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {buttonText}
              </Button>
            )}
          </div>
        </div>
        <div className={styles.rightSide}>
          <h2
            className={styles.title}
            style={{ color: titleColor }}
            data-aos="fade-down"
            data-aos-delay="100"
          >
            {title}
          </h2>
          <img src={imageUrl} alt={title} className={styles.image} loading="lazy" data-aos="fade" />
        </div>
      </div>
    </div>
  );
};

export default FlyingText;
